import { useTranslation } from 'react-i18next';
import {
    Banner,
    BannerDescription,
    BannerEyebrow,
    BannerImage,
    BannerImageContainer,
    BannerLinks,
    BannerText,
    BannerTextContainer,
    BannerTitle,
    FluidImage,
    Link,
} from '@vp/swan';

export const PromotionsBanner = () => {
    const { t } = useTranslation();

    return (
        <Banner
            textBoxHorizontalAlign="right"
            backgroundColor="warm-white"
            as="section"
            id="design-services"
            marginY="between-sections"
        >
            <BannerImageContainer>
                <BannerImage>
                    <FluidImage
                        src={t('Logomaker GenAi Landing Page > Promotions Banner > Image.src')}
                    />
                </BannerImage>
            </BannerImageContainer>
            <BannerTextContainer>
                <BannerText>
                    <BannerEyebrow>
                        {t('Logomaker GenAi Landing Page > Promotions Banner > Eyebrow.value')}
                    </BannerEyebrow>
                    <BannerTitle as="h2">
                        {t('Logomaker GenAi Landing Page > Promotions Banner > Title.value')}
                    </BannerTitle>
                    <BannerDescription as="p">
                        {t('Logomaker GenAi Landing Page > Promotions Banner > Description.value')}
                    </BannerDescription>
                    <BannerLinks>
                        <Link
                            href={t(
                                'Logomaker GenAi Landing Page > Promotions Banner > CTA.contentfulUrl',
                            )}
                            skin="cta"
                        >
                            {t('Logomaker GenAi Landing Page > Promotions Banner > CTA.text')}
                        </Link>
                    </BannerLinks>
                </BannerText>
            </BannerTextContainer>
        </Banner>
    );
};
